/* unplugin-vue-components disabled */import { render } from "./audios.vue?vue&type=template&id=bb4bb8d0&scoped=true"
import script from "./audios.vue?vue&type=script&lang=js"
export * from "./audios.vue?vue&type=script&lang=js"

import "./audios.vue?vue&type=style&index=0&id=bb4bb8d0&scoped=true&lang=scss"
import "./audios.vue?vue&type=style&index=1&id=bb4bb8d0&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4bb8d0"]])

export default __exports__